"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var oj_utils_1 = require("oj-utils");
exports.closest = function (element, selector) {
    if (Element.prototype.closest)
        return element.closest(selector);
    else {
        if (!Element.prototype.matches)
            Element.prototype.matches =
                Element.prototype["matchesSelector"] ||
                    Element.prototype["mozMatchesSelector"] ||
                    Element.prototype["msMatchesSelector"] ||
                    Element.prototype["oMatchesSelector"] ||
                    Element.prototype["webkitMatchesSelector"] ||
                    function (s) {
                        var matches = (this.document || this.ownerDocument).querySelectorAll(s), i = matches.length;
                        while (--i >= 0 && matches.item(i) !== this) { }
                        return i > -1;
                    };
        do {
            if (element.matches(selector))
                return element;
            element = element.parentElement || element.parentNode;
        } while (element !== null && element.nodeType === 1);
        return null;
    }
};
exports.getTransitionDuration = function (element, deep) {
    var duration = Math.max.apply(Math, (window.getComputedStyle(element).transitionDuration || "0").split(",").map(function (x) { return parseFloat(x); }));
    var delay = Math.max.apply(Math, (window.getComputedStyle(element).transitionDelay || "0").split(",").map(function (x) { return parseFloat(x); }));
    var totalTime = (duration + delay) * 1000;
    if (deep)
        totalTime += Array.from(element.children || []).reduce(function (sum, x) { return sum += exports.getTransitionDuration(x, deep); }, 0);
    return totalTime;
};
exports.replaceElement = function (html) {
    var id = exports.getIdFromHTML(html);
    if (!id)
        throw new Error("no target id found in the given html");
    var target = document.getElementById(id);
    if (!target)
        throw new Error("no target id found for id " + id);
    return exports.injectHTML(target, html);
};
exports.getOuterHeight = function (element) {
    var styles = getComputedStyle(element);
    return parseFloat(styles.height || "0") +
        parseFloat(styles.marginTop || "0") +
        parseFloat(styles.marginBottom || "0") +
        parseFloat(styles.paddingTop || "0") +
        parseFloat(styles.paddingBottom || "0");
};
exports.getOuterWidth = function (element) {
    var styles = getComputedStyle(element);
    return parseFloat(styles.width || "0") +
        parseFloat(styles.marginLeft || "0") +
        parseFloat(styles.marginRight || "0") +
        parseFloat(styles.paddingLeft || "0") +
        parseFloat(styles.paddingRight || "0");
};
exports.getOffsetsOnPage = function (element) {
    var _x = 0;
    var _y = 0;
    while (element && !isNaN(element.offsetLeft) && !isNaN(element.offsetTop)) {
        _x += element.offsetLeft - element.scrollLeft;
        _y += element.offsetTop - element.scrollTop;
        element = element.offsetParent;
    }
    return { top: _y, left: _x };
};
exports.withinViewport = function (element) {
    var rect = element.getBoundingClientRect();
    return rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
exports.getIdFromHTML = function (html) {
    var matchedId = html.match(/id="([^"]*?)"/);
    return matchedId ? matchedId[1] : null;
};
exports.injectHTML = function (placeholder, html) {
    var parent = placeholder.parentNode;
    var nextWrapper = document.createElement("div");
    nextWrapper.innerHTML = html;
    var next = [];
    for (var i = nextWrapper.children.length - 1; i >= 0; i--) {
        next.push(parent.insertBefore(nextWrapper.children[i], placeholder));
    }
    parent.removeChild(placeholder);
    return next;
};
exports.childOf = function (container, child) {
    var el = child;
    if (!el)
        return false;
    while (el !== container) {
        if (!el.parentNode)
            return false;
        el = el.parentNode;
    }
    return true;
};
exports.getEventProps = function (e) {
    if (e.targetTouches && e.targetTouches[0])
        return e.targetTouches[0];
    if (e.changedTouches && e.changedTouches[0])
        return e.changedTouches[0];
    return e;
};
exports.getOffsetX = function (e) {
    var x = 0;
    var elem = e.target;
    while (elem) {
        x += parseInt(elem.offsetLeft);
        elem = elem.offsetParent;
    }
    return exports.getEventProps(e).pageX - x;
};
exports.getOffsetY = function (e) {
    var y = 0;
    var elem = e.target;
    while (elem) {
        y += parseInt(elem.offsetTop);
        elem = elem.offsetParent;
    }
    return exports.getEventProps(e).pageY - y;
};
exports.sanitizeHTML = function (html) {
    var ta = document.createElement("textarea");
    ta.innerHTML = html;
    return (ta.value || html)
        .replace(/NS\d+:href/gi, 'xlink:href')
        .replace(/[\u00A0-\u9999\&]/gm, function (i) { return "&#" + i.charCodeAt(0) + ";"; });
};
exports.animatePolygonPoints = function (element, from, to, bezier, duration) {
    if (duration === void 0) { duration = 500; }
    return new Promise(function (r) {
        var map = function (str) { return str.split(" ").map(function (x) { return x.split(",").map(function (x) { return parseFloat(x); }); }); };
        from = map(from);
        to = map(to);
        var state = from.map(function (x) { return []; });
        var delay = 25;
        var iterations = Math.round(duration / delay);
        var iteration = 0;
        var run = function () {
            var part = bezier(iteration++ / iterations);
            for (var i = 0; i < from.length; i++)
                for (var j = 0; j < from[i].length; j++)
                    state[i][j] = from[i][j] + ((to[i][j] - from[i][j]) * part);
            element.setAttribute("points", state.join(" "));
            if (part < 1)
                setTimeout(run, delay);
            else
                r();
        };
        run();
    });
};
exports.stopEvent = function (e, redraw) {
    if (redraw === void 0) { redraw = true; }
    e.stopPropagation();
    e.preventDefault();
    e.redraw = redraw;
};
exports.ellipsis = function (dom, options) {
    var txt = dom.innerText;
    var i = 1;
    var shrink = function () { return dom.innerText = txt.substring(0, txt.length - ++i) + "..."; };
    if (options.width)
        while (dom.offsetWidth > options.width)
            shrink();
    if (options.height)
        while (dom.offsetHeight > options.height)
            shrink();
    if (options.watch === true)
        window.addEventListener("resize", oj_utils_1.debounce(function (e) {
            dom.innerText = txt;
            exports.ellipsis(dom, __assign(__assign({}, options), { watch: false }));
        }));
    return dom.innerText;
};
exports.scrollDirection = function (fn, delayed, scope) {
    if (delayed === void 0) { delayed = 0; }
    if (scope === void 0) { scope = null; }
    var prevDirections = [];
    var prev = 0;
    var element;
    return function () {
        var args = arguments;
        if (!element)
            element = args[0].currentTarget;
        var curr = element.pageYOffset || element.scrollTop;
        if (curr === prev)
            return;
        var direction = curr > prev ? 1 : -1;
        args[0].direction = direction;
        prev = curr;
        if (delayed) {
            prevDirections.push(direction);
            if (prevDirections.length > delayed)
                prevDirections.shift();
            if (prevDirections.length === delayed && prevDirections.every(function (x) { return x === prevDirections[0]; })) {
                fn.apply(scope, args);
            }
        }
        else {
            fn.apply(scope, args);
        }
    };
};
exports.doubletap = function (fn, threshold) {
    if (threshold === void 0) { threshold = 400; }
    var c = false;
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        if (c) {
            fn.apply(void 0, args);
            c = false;
        }
        else {
            c = true;
            t = setTimeout(function () { return c = false; }, threshold);
            args[0].redraw = false;
        }
    });
};
exports.getRootElements = function (selector, loaded) {
    var elements = Array.from(document.querySelectorAll(selector));
    if (!loaded)
        return elements;
    elements = elements.filter(function (x) { return !x.getAttribute("data-loaded"); });
    elements.forEach(function (x) { return x.setAttribute("data-loaded", "=D"); });
    return elements;
};
exports.getGFontsURL = function (html) {
    var matches = html.replace(/&quot;/g, "").match(/font-family: ?(.*?);/g);
    if (!matches)
        return "";
    var families = matches.map(function (x) {
        var f = x.replace(/ ?!important/, "");
        return f.substring(12, f.length - 1).trim();
    }).filter(function (v, i, a) { return a.indexOf(v) === i; });
    var string = families.reduce(function (str, x, i) { return str += "" + (i > 0 ? "|" : "") + x; }, "").replace(/ /g, "+");
    return "<link href=\"https://fonts.googleapis.com/css?family=" + string + "\" rel=\"stylesheet\">";
};
exports.isAcceptable = function (acceptRule, filename, mime) {
    for (var _i = 0, _a = acceptRule.split(","); _i < _a.length; _i++) {
        var specifier = _a[_i];
        if (specifier.startsWith(".")) {
            // match complete extensions
            var extension = filename.split(".").pop();
            if (!extension || extension === filename)
                continue;
            if (specifier === "." + extension)
                return true;
        }
        else {
            // match complete mime type with wildcards
            var regex = new RegExp("^" + specifier.split("*").join(".*") + "$");
            if (regex.test(mime))
                return true;
        }
    }
    return false;
};
